import { MOBILES } from "../constants";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

// a11y hamburger https://foxland.fi/simple-accessible-svg-menu-hamburger-animation
export function hamburger(element) {
	const button = document.getElementById(element);
	const burgerModal = $(".header__wrapper");

	if (!button) {
		return false;
	}
	if (MOBILES.matches) {
		$(".logo").after($(".header__link_profile"));
	}

	button.onclick = () => {
		if (button.className.indexOf("opened") !== -1) {
			button.className = button.className.replace(" opened", "");
			button.setAttribute("aria-expanded", "false");
			document.querySelector(`.body`).classList.remove(`body_overlay`);
			document.documentElement.classList.remove(`html_overlay`);
			enableBodyScroll(burgerModal);
			//Для рубина
			$('.profile-pic').show();
		} else {
			button.className += " opened";
			button.setAttribute("aria-expanded", "true");
			document.querySelector(`.body`).classList.add(`body_overlay`);
			document.documentElement.classList.add(`html_overlay`);
			$(".js-search-form").slideUp("fast");
			$(".js-header-login").prependTo(".js-header-top");
			disableBodyScroll(burgerModal);
			//Для рубина
			$('.profile-pic').hide();
			
		}
	};

	return false;
}
